import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename", "label"];
import { memo, useEffect } from 'react';
import { Input, useStore } from 'react-login-page';
import { EmailIcon } from '../icons/email';
import { jsx as _jsx } from "react/jsx-runtime";
export var Email = /*#__PURE__*/memo(props => {
  var {
      keyname = 'email',
      name,
      rename,
      label = 'Email:'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var {
    dispatch
  } = useStore();
  if (!elmProps.children) {
    elmProps.children = EmailIcon;
  }
  var nameBase = name || rename || keyname;
  var key = keyname || name;
  useEffect(() => dispatch({
    ["$" + key]: label
  }), [label]);
  return /*#__PURE__*/_jsx(Input, _extends({
    type: "email",
    placeholder: "Email",
    index: 1,
    spellCheck: false
  }, elmProps, {
    name: nameBase,
    keyname: key
  }));
});
Email.displayName = 'Login.Email';